import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { useAppData } from '../../context/AppDataContext';
import ManagementPageSkeleton from '../../components/layout/ManagementPageSkeleton';
import { getStoreHubPath } from './storeHubTabs';

const StoreHubRedirect = ({ tab }) => {
  const { storeId } = useParams();
  const { currentStore, stores, storesLoading } = useAppData();
  const targetExists = Boolean(storeId && stores.some((store) => store.id === storeId));
  const storeReady = !targetExists || currentStore?.id === storeId;

  if (storesLoading || !storeReady) {
    return <ManagementPageSkeleton variant="detail" />;
  }

  return <Navigate to={getStoreHubPath(tab)} replace />;
};

export default StoreHubRedirect;
